import { RefObject, useCallback } from "react"

const regex = /(?:^|\s)(@([^\s@]*))$/
const START_INDEX = 0

interface Props {
  inputRef: RefObject<HTMLInputElement>
}

export default function useDetectTrigger({ inputRef }: Props) {
  const detectTrigger = useCallback(() => {
    if (
      !inputRef ||
      !inputRef.current ||
      inputRef.current.selectionEnd === null
    )
      return
    const value = inputRef.current.value
    const position = inputRef.current.selectionEnd
    const positionValue = value?.substring(START_INDEX, position)

    const match = positionValue.match(regex)

    return match ? match[2] : null
  }, [inputRef])

  return detectTrigger
}
